import { render, staticRenderFns } from "./Boxer.vue?vue&type=template&id=8f8eb550&"
import script from "./Boxer.vue?vue&type=script&lang=js&"
export * from "./Boxer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports